import { Megaphone } from 'lucide-react'

import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

import { RECALL_EVENT_COPY } from '#app/routes/mocra+/_form+/components/recall-events/constants.ts'
import {
	formatRecallEventSummary,
	recallEventCardTitle,
	type RecallEventDraft,
} from '#app/routes/mocra+/_form+/components/recall-events/types.ts'

type Props = {
	readonly event: RecallEventDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly errors?: readonly string[]
}

export function RecallEventCard({ event, onEdit, onRemove, errors }: Props) {
	const title = recallEventCardTitle(event)
	const summary = formatRecallEventSummary(event)
	const hasErrors = Boolean(errors && errors.length > 0)
	const firstError = hasErrors ? errors?.[0] : null
	const description = hasErrors
		? `${summary} • ${firstError ?? 'Needs attention'}`
		: summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeLabel="Remove"
			removeConfirmTitle={RECALL_EVENT_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				RECALL_EVENT_COPY.actions.removeConfirmDescription
			}
			icon={<Megaphone className="text-muted-foreground h-3.5 w-3.5" />}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove recall history event"
		/>
	)
}
